<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.status')}}</v-list-item-title>
    <v-row class="pb-1 pt-3 full-width">
      <v-col
      v-for="(status, index) in statuses"
      :key="index"
      class="pa-0 px-2"
      >
      <v-checkbox
      v-model="selectedStatusesModel"
      :value="status"
      dense
      >
      <template v-slot:label>
        <span class="insights-filter-text">{{ status.name }}</span>
      </template>
    </v-checkbox>
  </v-col>
</v-row>
</v-list-item>
</template>

<script>
export default {
  name: 'StatusFilter',
  data () {
    return {
      statuses: [
        { value: true, name: this.$t('insights.filters.activeStatus') },
        { value: false, name: this.$t('insights.filters.closedStatus') }
      ]
    }
  },
  props: {
    selectedStatuses: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['selectedStatusInput'],
  computed: {
    selectedStatusesModel: {
      get () {
        return this.selectedStatuses
      },
      set (value) {
        this.$emit('selectedStatusInput', value)
      }
    }
  }
}
</script>

<style>
</style>
